import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import Question from './question';
import { Formik } from 'formik';
import { FormikChange } from '../../libs/Formik';
import { SurveyContext } from '../surveycontext';


class Survey extends Formik {

    constructor(props) {
        super(props);

    }


    render() {
        const currentQuestion = this.context.getCurrentQuestion();
        return (
            <React.Fragment>
                <div className='ui segment survey'>
                    <Question {...currentQuestion} />
                </div>
            </React.Fragment>
        );
    }
}

Survey.contextType = SurveyContext;
export default Survey;